import React from "react";

export const GeoTest = ({ geo_code, children }) => (
  <a href={`https://www.google.com/maps/@${geo_code},18z`} target="_blank">
    {children}
  </a>
);
